import { Box, Typography, Paper } from '@mui/material';

export const HomePage = () => {
  return (
    <Box>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Welcome to ERP Elint
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Your SaaS ERP solution is ready to be built.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          This is a monolithic application structure that can be migrated to
          micro-frontend architecture in the future.
        </Typography>
      </Paper>
    </Box>
  );
};

